export default __webpack_public_path__ + "2f3e98830cc9c11524e7efadedb102ca.png";